import React from "react";

export default function ResolvedBadge() {
  return (
    <span className="text-success">
      <i className="fa fa-fw fa-check" /> Resolved
    </span>
  );
}



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/Discrepancies/ResolvedBadge.jsx